export default "__VITE_ASSET__CP75CfFE__"